import React from 'react';
import { X } from 'lucide-react';
import { SheetTitle, SheetDescription } from '../../ui/Sheet/Sheet';

export interface DrawerHeaderProps {
  title: string;
  subtitle?: React.ReactNode;
  onClose: () => void;
}

export const DrawerHeader: React.FC<DrawerHeaderProps> = ({
  title,
  subtitle,
  onClose,
}) => {
  return (
    <div className="flex items-center justify-between gap-4 px-5 pt-4 pb-1 shrink-0">
      <div className="flex flex-col gap-0.5 min-w-0">
        <SheetTitle className="text-base font-semibold truncate">{title}</SheetTitle>
        <SheetDescription className={subtitle ? 'text-sm text-muted-foreground truncate' : 'sr-only'}>
          {subtitle ?? ''}
        </SheetDescription>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="inline-flex items-center justify-center rounded-md p-1.5 text-muted-foreground hover:text-foreground hover:bg-muted transition-colors shrink-0"
      >
        <X className="size-4" />
        <span className="sr-only">Close</span>
      </button>
    </div>
  );
};
